import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'
import { CommonConstants } from '../../Constants'
export default class SecurityService {
  constructor () {
    this.authService = new AuthenticationService(Config.authBaseUrl)
  }
  /// change function to callback to update change permission immediately
  hasAccess (permission, cb) {
    let access = false
    /// special permission only for EditStoreBasic
    /// For Admin, we are allowing the store name to be edit on the behalf of customer
    if (permission === CommonConstants.userPermissions.EditStoreBasic &&
        this.authService.isAdmin() && this.checkUserUUID()) {
      access = true
    } else if (this.authService.isAdmin()) {
      // This will not allow the admin to perform add and remove users and roles.
      let adminPermissions = Config.excludePermissionsForAdmin
      if (adminPermissions.indexOf(permission) > -1) {
        access = false
      } else {
        access = true
      }
      if (cb !== undefined) cb(access)
    } else {
      // This will allow the Account owner to perform all permissions/actions.
      if (this.authService.getProfile().IsAccountOwner === 1) {
        access = true
        if (cb !== undefined) cb(access)
      } else {
        // Getting the permissions from the service and checking.
        // For Non account owner - checking the permissions which stored in local.
        const permissions = this.authService.getPermission()
        if (permissions && permissions.length > 0) {
          if (permissions.indexOf(permission) > -1) {
            access = true
          } else {
            access = false
          }
          if (cb !== undefined) cb(access)
        }
      }
    }
    return access
  }

  checkUserUUID () {
    if (window.location) {
      const params = new URLSearchParams(window.location.search)
      if (params) {
        const uuid = params.get('uuid') ? params.get('uuid') : null
        if (uuid === 'null' || uuid === null) {
          return false
        } else {
          return true
        }
      }
      return false
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/Security/SecurityService.js